import React from 'react';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();

  return (
    <header className="App-header">
      <div className="header-content">
        <a href="/" onClick={(e) => {
          e.preventDefault();
          navigate('/');
        }}>
          <img src="/logoq.svg" className="logo" alt="Qulpynai logo" />
        </a>
      </div>
    </header>
  );
}

export default Header; 